type InformationRequestStatusBearer = {
  company_information_request_status?: number | null;
};

export const getExpirationDate = (expirationDate?: string | Date | null): Date | null => {
  if (!expirationDate) {
    return null;
  }

  const parsed = expirationDate instanceof Date ? expirationDate : new Date(expirationDate);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const isExpirationDatePassed = (expirationDate: Date) => expirationDate.getTime() <= Date.now();

export const formatExpirationDate = (date: Date) => {
  const now = new Date();
  const diff = Math.max(date.getTime() - now.getTime(), 0);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / 1000 / 60) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return `${days} ${hours} ${minutes} ${seconds}`;
};

export const getInformationRequestStatusId = (
  ...itemGroups: Array<InformationRequestStatusBearer[] | undefined>
): number | undefined =>
  itemGroups
    .flatMap(items => items ?? [])
    .find(item => item.company_information_request_status)?.company_information_request_status ?? undefined;
